import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    enabled: false,
    from: { day: null, month: null },
    to: { day: null, month: null },
};
const scheduleSlice = createSlice({
    name: "userSchedule",
    initialState,
    reducers: {
        setScheduleEnabled: (state, action) => {
            state.enabled = action.payload;
        },
        setStartMonth: (state, action) => {
            state.from.month = action.payload;
            state.from.day = null;
            state.to = { day: null, month: null };
        },
        setStartDay: (state, action) => {
            state.from.day = action.payload;
        },
        setEndMonth: (state, action) => {
            state.to.month = action.payload;
            state.to.day = null;
        },
        setEndDay: (state, action) => {
            state.to.day = action.payload;
        },
        resetSchedule: () => initialState,
    },
});
export const { setScheduleEnabled, setStartMonth, setStartDay, setEndMonth, setEndDay, resetSchedule, } = scheduleSlice.actions;
export default scheduleSlice.reducer;
